// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"ProvidersTable_buttonGroup__393yi","header":"ProvidersTable_header__1Ah_Q"};